import { render } from "./BuyListedNftModal.vue?vue&type=template&id=5ba1efa4&scoped=true"
import script from "./BuyListedNftModal.vue?vue&type=script&lang=js"
export * from "./BuyListedNftModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/buyListedNft.scss?vue&type=style&index=0&id=5ba1efa4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba1efa4"]])

export default __exports__